import {
  IAdministrator,
  ILocation,
} from '@boma/supplier-portal/shared/entities';
import {
  IAssignedAdminRoles,
  IPaginatedResponse,
  IRole,
} from '@boma/client-shared';
import { createAction, props } from '@ngrx/store';

export const loadLocations = createAction(
  '[Locations] Load Locations',
  props<{ query?: string; page?: number; locationType?: string }>()
);

export const setLocationPage = createAction(
  '[Locations] Set Location Page',
  props<{ page: number }>()
);

export const setLocationQuery = createAction(
  '[Locations] Set Location Query',
  props<{ query: string }>()
);

export const loadLocationsSuccess = createAction(
  '[Locations] Load Locations Success',
  props<{ payload: IPaginatedResponse<ILocation> }>()
);

export const clearSelectedLocation = createAction(
  '[Locations] Clear Selected Location'
);

export const loadLocationsFailure = createAction(
  '[Locations] Load Locations Failure',
  props<{ error: any }>()
);

export const createLocation = createAction(
  '[Locations] Create Location',
  props<{ location: ILocation }>()
);

export const createLocationSuccess = createAction(
  '[Locations]  Create Location Success',
  props<{ location: ILocation }>()
);

export const createLocationFailure = createAction(
  '[Locations]  Create Location Failure',
  props<{ error: any }>()
);

export const loadLocation = createAction(
  '[Locations] Load Location',
  props<{ id: string }>()
);

export const loadLocationSuccess = createAction(
  '[Locations] Load Location Success',
  props<{ location: ILocation }>()
);

export const loadLocationFailure = createAction(
  '[Locations] Load Location Failure',
  props<{ error: any }>()
);

export const updateLocation = createAction(
  '[Locations] Update Location',
  props<{ location: ILocation }>()
);

export const updateLocationSuccess = createAction(
  '[Locations]  Update Location Success',
  props<{ location: ILocation }>()
);

export const updateLocationFailure = createAction(
  '[Locations]  Update Location Failure',
  props<{ error: any }>()
);

export const updateLocationPermissions = createAction(
  '[Locations] Update Location Permissions',
  props<{
    entityId: string;
    locationId: string;
    userId: string;
    roleIds: string[];
  }>()
);

export const updateLocationPermissionsSuccess = createAction(
  '[Locations] Update Location Permissions Success',
  props<{ payload: IAssignedAdminRoles }>()
);

export const updateLocationPermissionsFailure = createAction(
  '[Locations] Update Location Permissions Failure',
  props<{ error: any }>()
);

export const loadLocationAdministrators = createAction(
  '[Locations] Load Administrators',
  props<{ locationId: string; query: string }>()
);

export const loadLocationAdministratorsSuccess = createAction(
  '[Locations] Load Administrators Success',
  props<{ administrators: IAdministrator[] }>()
);

export const loadLocationAdministratorsFailure = createAction(
  '[Locations] Load Administrators Failure',
  props<{ error: any }>()
);

export const loadLocationAdministratorDetails = createAction(
  '[Locations] Load Administrator',
  props<{ adminId: string; locationId: string }>()
);

export const loadLocationAdministratorDetailsSuccess = createAction(
  '[Locations] Load Administrator Success',
  props<{ administrator: IAdministrator }>()
);

export const loadLocationAdministratorDetailsFailure = createAction(
  '[Locations] Load Administrator Failure',
  props<{ error: any }>()
);

export const loadLocationRoles = createAction('[Locations] Load Roles');

export const loadLocationRolesSuccess = createAction(
  '[Locations] Load Roles Success',
  props<{ payload: IPaginatedResponse<IRole> }>()
);

export const loadLocationRolesFailure = createAction(
  '[Locations] Load Roles Failure',
  props<{ error: any }>()
);

export const deleteLocationAdministrator = createAction(
  '[Locations] Delete Administrator',
  props<{ userId: string; locationId: string }>()
);

export const deleteLocationAdministratorSuccess = createAction(
  '[Locations] Delete Administrator Success',
  props<{ userId: string }>()
);

export const createLocationAdministrator = createAction(
  '[Locations] Create Administrator',
  props<{
    locationId: string;
    emailAddressOrPhoneNumber: string;
    roleIds: string[];
  }>()
);

export const createLocationAdministratorSuccess = createAction(
  '[Locations] Create Administrator Success',
  props<{ administrator: IAdministrator }>()
);

export const updateLocationAdministrator = createAction(
  '[Locations] Update Administrator',
  props<{ locationId: string; userId: string; roleIds: string[] }>()
);

export const updateLocationAdministratorSuccess = createAction(
  '[Locations] Update Administrator Success',
  props<{ administrator: IAdministrator }>()
);
